import { motion } from "framer-motion";

const PHOTOS = [
  {
    src: "https://images.unsplash.com/photo-1742940796376-8f34cb25be44?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxjYXIlMjB0cmFuc3BvcnQlMjBjYXJyaWVyJTIwdHJ1Y2slMjBzaGlwcGluZ3xlbnwwfHx8fDE3OTE3NDI3NDZ8MA&ixlib=rb-4.1.0&q=85",
    caption: "Car carrier fleet · ready for dispatch",
    span: "g-wide",
  },
  {
    src: "https://images.unsplash.com/photo-1541544181051-e46607bc22a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MDV8MHwxfHNlYXJjaHwzfHxidWJibGUlMjB3cmFwJTIwcGFja2luZyUyMGJveCUyMGZyYWdpbGUlMjBkZXRhaWwlMjBoYW5kcyUyMHRhcGV8ZW58MHx8fDE3OTE3NDI4MTR8MA&ixlib=rb-4.1.0&q=85",
    caption: "Every fragile item, wrapped twice",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1646194118794-9cd7b10409a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY6NzV8MHwxfHNlYXJjaHw0fHxvZmZpY2UlMjByZWxvY2F0aW9uJTIwZXF1aXBtZW50JTIwYm94ZXMlMjBkZXNrJTIwbW92aW5nfGVufDB8fHx8MTc5MTc0MjgxNHww&ixlib=rb-4.1.0&q=85",
    caption: "Office move · labelled and logged",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHx3YXJlaG91c2UlMjBzdG9yYWdlJTIwcmFja3MlMjBib3hlcyUyMGxvZ2lzdGljcyUyMGNsZWFufGVufDB8fHx8MTc5MTc0MjgxNHww&ixlib=rb-4.1.0&q=85",
    caption: "Our Patna storage facility",
    span: "g-tall",
  },
  {
    src: "https://images.unsplash.com/photo-1686246668933-7425658394b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHw0fHxjYXIlMjB0cmFuc3BvcnQlMjBjYXJyaWVyJTIwdHJ1Y2slMjBzaGlwcGluZ3xlbnwwfHx8fDE3OTE3NDI3NDZ8MA&ixlib=rb-4.1.0&q=85",
    caption: "Flatbed transport · zero scratches",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1714647211902-bb711d643a17?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxwYWNraW5nJTIwaG91c2Vob2xkJTIwZnVybml0dXJlJTIwaG9tZSUyMG1vdmluZyUyMGJveGVzJTIwbW92ZXJzfGVufDB8fHx8MTc5MTc0MjgxNHww&ixlib=rb-4.1.0&q=85",
    caption: "Home shifting · packed with care",
    span: "",
  },
];

export const Gallery = () => (
  <section className="section gallery-section" id="gallery">
    <div className="container">
      <div className="section-heading">
        <div>
          <p className="overline">On the road</p>
          <h2>Real trucks. <em>Real moves.</em></h2>
        </div>
        <p className="section-sub">A look at our fleet, our packing crews and the journeys in between.</p>
      </div>
      <div className="gallery-grid" data-testid="gallery-grid">
        {PHOTOS.map((photo, i) => (
          <motion.figure
            key={photo.src}
            className={`gallery-item ${photo.span}`}
            data-testid={`gallery-item-${i + 1}`}
            initial={{ opacity: 0, y: 26 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: i * 0.06, duration: 0.65, ease: [0.16, 1, 0.3, 1] }}
          >
            <img src={photo.src} alt={photo.caption} loading="lazy" />
            <figcaption>{photo.caption}</figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
